import { Link } from "react-router-dom";
import { Nav } from "../components/Nav";
import { Sparkles } from "lucide-react";

const UPDATED = "June 18, 2026";

function Section({ n, title, children }) {
  return (
    <section className="mt-8">
      <h2 className="text-xl sm:text-2xl font-display font-bold">{n}. {title}</h2>
      <div className="text-[#4A4A4A] leading-relaxed mt-2 space-y-3">{children}</div>
    </section>
  );
}

export default function Privacy() {
  return (
    <div className="min-h-screen">
      <Nav />
      <div className="max-w-3xl mx-auto px-5 py-10">
        <Link to="/" className="flex items-center gap-2 font-display font-bold text-lg"><Sparkles className="w-5 h-5" /> SendOccasions</Link>
        <h1 className="text-3xl sm:text-4xl font-display font-bold mt-4">Privacy Policy</h1>
        <p className="text-sm text-[#4A4A4A] mt-2">Last updated: {UPDATED}</p>

        <div className="nb-card p-5 mt-6 bg-[#A8E6CF]">
          <p className="text-sm font-semibold text-[#0A0A0A]">Plain-English summary: We collect the minimum needed to run the app (your name, email, the greetings you make, and basic location for ad targeting). We never sell your personal data. Passwords are encrypted.</p>
        </div>

        <Section n="1" title="Information We Collect">
          <p><strong>Account information:</strong> your name and email address when you sign up.</p>
          <p><strong>Content you create:</strong> greeting messages, recipient names, uploaded photos/selfies, and chosen templates.</p>
          <p><strong>Usage & device data:</strong> approximate location derived from your IP address (used to show geo-relevant ads), and basic analytics about how the Service is used.</p>
          <p><strong>Advertiser data:</strong> business name, ad creative, target area, and payment status (payment card data is handled by Stripe, not stored by us).</p>
        </Section>

        <Section n="2" title="How We Use Your Information">
          <p>To provide and operate the Service; create and deliver greetings; show relevant (geo-targeted) advertising; process advertiser payments; send transactional emails (such as greeting delivery and password resets); maintain security; and improve the Service.</p>
        </Section>

        <Section n="3" title="Passwords & Security">
          <p>Your password is stored only as a one-way encrypted hash (bcrypt) and is never visible to us or anyone else. We use reasonable technical measures to protect your data, but no method of transmission or storage is 100% secure.</p>
        </Section>

        <Section n="4" title="Third-Party Services">
          <p>We use trusted third parties to operate the Service, including <strong>Stripe</strong> (payment processing), <strong>Resend</strong> (email delivery), and cloud storage/hosting providers. These providers process data only as needed to perform their services and under their own privacy policies.</p>
        </Section>

        <Section n="5" title="Cookies & Local Storage">
          <p>We use local storage to keep you signed in (an authentication token). We do not use third-party advertising trackers to follow you across other websites.</p>
        </Section>

        <Section n="6" title="Sharing of Information">
          <p>We do <strong>not</strong> sell your personal information. Greetings you create are accessible to anyone who has the share link you choose to distribute. We may disclose information if required by law or to protect our rights and users' safety.</p>
        </Section>

        <Section n="7" title="Data Retention">
          <p>We retain your account and content for as long as your account is active or as needed to provide the Service. You may request deletion of your account and associated personal data by contacting us.</p>
        </Section>

        <Section n="8" title="Children's Privacy">
          <p>The Service is not directed to children under 13, and we do not knowingly collect personal information from them. If you believe a child has provided us information, contact us and we will delete it.</p>
        </Section>

        <Section n="9" title="Your Rights">
          <p>Depending on your location, you may have rights to access, correct, or delete your personal data, or to object to certain processing. To exercise these rights, contact us at the email below.</p>
        </Section>

        <Section n="10" title="Changes to This Policy">
          <p>We may update this Privacy Policy from time to time. Material changes will be reflected by updating the "Last updated" date above.</p>
        </Section>

        <Section n="11" title="Contact">
          <p>Questions about your privacy? Contact us at support@sendoccasions.com.</p>
        </Section>

        <div className="nb-card p-4 mt-10 text-xs text-[#4A4A4A]">
          This document is a general template provided for convenience and is not legal advice. Please have a qualified attorney review it before launch, especially for GDPR/CCPA and app-store requirements.
        </div>

        <p className="mt-8"><Link to="/terms" className="font-bold underline">Read our Terms of Service →</Link></p>
      </div>
    </div>
  );
}
